import dayjs from 'dayjs';
import React from 'react';
import { Select } from '.';

const SelectMonth: React.FC<React.HTMLProps<HTMLInputElement> & { onChange: (e: any) => void }> = (props) => {
    const [value, setValue] = React.useState({
        y: null,
        m: null,
    });
    const optionYear = [];
    const optionMonth = [];

    for (let i = new Date().getFullYear(); i >= 1900; i--) {
        optionYear.push({ label: `${i}`, value: `${i}` });
    }
    for (let i = 1; i <= 12; i++) {
        optionMonth.push({ label: `${i}`, value: `${i}` });
    }

    const handleChange = React.useCallback((type: 'year' | 'month', e) => {
        const newValue = (type === 'year') ? { y: e.value } : { m: e.value };
        setValue({
            ...value,
            ...newValue,
        });
    }, [value, props.onChange]);

    React.useEffect(() => {
        if(value.y && value.m) {
            props.onChange(`${value.y}-${`${value.m}`.padStart(2, '0')}-01`);
        }
    }, [value]);

    return (
        <div>
            <div style={{ width: '33%', display: 'inline-block' }}>
                <Select options={optionYear} placeholder="年" onChange={(e) => handleChange('year', e)}></Select>
            </div>
            <div style={{ width: '33%', display: 'inline-block' }}>
                <Select options={optionMonth} placeholder="月" onChange={(e) => handleChange('month', e)}></Select>
            </div>
        </div>
    );
}

export default SelectMonth;

